import React from 'react'
import { FormattedMessage, intlShape } from 'react-intl'

// Components
import { Button } from 'src/Components'

// Utils
import history from 'src/history'

// Constants
import { OVERLAY_HELPERS } from 'src/constants/navigation'

import styles from './AirDnaLearnMoreButton.module.scss'

const propTypes = {
  intl: intlShape
}

const AirDnaLearnMoreButton = ({ intl }) => {
  const openLearnMorPanel = () => {
    history.push(OVERLAY_HELPERS.airDnaLearnMore.buildPath())
  }

  return (
    <>
      <div className={styles.buttonContainer}>
        <Button onClick={openLearnMorPanel}>
          <FormattedMessage
            id='AirDna.additionalInfo.learnMore'
            defaultMessage='Can you help me learn more?'
          />
        </Button>
      </div>
    </>
  )
}

AirDnaLearnMoreButton.propTypes = propTypes

export default AirDnaLearnMoreButton
